const doc = [({"zh_tw":({"adminButtonHotelCancelPolicy":({"cancelPolicySetting":"取消規則設定", "deleteCancelPolicy":"刪除取消規則", "deleteCancelPolicySetting":"刪除取消策略設置"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;